import { Theme } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { ScrollbarsProps } from './Scrollbars.types';

type Props = Pick<ScrollbarsProps, 'offset'>;

export const useStyles = makeStyles<Theme, Props>({
  scrollbars: {
    margin: ({ offset }) =>
      typeof offset?.width === 'number' || typeof offset?.height === 'number'
        ? `-${offset?.height ?? 0}px -${offset?.width ?? 0}px`
        : 'initial',
    width: ({ offset }) =>
      typeof offset?.width === 'number' ? `calc(100% + ${offset.width * 2}px) !important` : 'initial',
    height: ({ offset }) =>
      typeof offset?.height === 'number' ? `calc(100% + ${offset.height * 2}px) !important` : 'initial',
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: ({ offset }) =>
      typeof offset?.width === 'number' || typeof offset?.height === 'number'
        ? `${offset?.height ?? 0}px ${offset?.width ?? 0}px`
        : 'initial',
  },
  trackVertical: {
    zIndex: 20,
    position: 'absolute',
    width: '6px',
    transition: 'opacity 200ms ease 0s',
    right: '2px',
    bottom: '2px',
    top: '2px',
    borderRadius: '3px',
  },
  trackHorizontal: {
    zIndex: 20,
    position: 'absolute',
    height: '6px',
    transition: 'opacity 200ms ease 0s',
    right: '2px',
    bottom: '2px',
    left: '2px',
    borderRadius: '3px',
  },
  thumbVertical: {
    zIndex: 20,
    position: 'relative',
    display: 'block',
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
  thumbHorizontal: {
    zIndex: 20,
    position: 'relative',
    display: 'block',
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
});
